import { ButtonView, SubmitButtonView } from '@vivli/shared/views';
import { CSSProperties, useMemo } from 'react';
import { useDisclosureContext } from '@vivli/features/disclosures/infrastructure/context';
import { useFormState } from 'react-hook-form';

const buttonContainerStyle: CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'auto auto auto auto',
    columnGap: '1em'
};

export const DisclosureHeaderView = () => {
    const {
        isLoading,
        permissions,
        reviewDocsPackageApi,
        disclosure,
        user,
        onSaveClick,
        onSubmitClick,
        onReturnToDraftClick,
        onFinalizedClick,
        onPublishedClick,
        onNotPublishedClick
    } = useDisclosureContext();
    const { isDirty, isValid } = useFormState();
    const documentsForReview = reviewDocsPackageApi?.dataPackage?.dataPackageFileDescriptors;

    return (
        <div style={buttonContainerStyle}>
            {/*'Saving this for future use if we implement this req'*/}
            {/*<ButtonView title={'Delete Displayed Disclosure'} style={deleteBtnStyle} dataId={'disclosure-delete-btn'}>*/}
            {/*    Delete Displayed Disclosure*/}
            {/*</ButtonView>*/}
            {permissions.markReviewComplete && (
                <ButtonView
                    title={'Mark Review Completed'}
                    theme={'darkgreen-on-white'}
                    onClick={onFinalizedClick}
                    dataId={'disclosure-approve-btn'}
                >
                    Mark Review Completed
                </ButtonView>
            )}

            {permissions.resetToDraft && (
                <ButtonView
                    title={'Reset to Draft'}
                    theme={'blue-on-white'}
                    onClick={onReturnToDraftClick}
                    dataId={'disclosure-reset-to-draft-btn'}
                    disabled={isLoading}
                >
                    Reset to Draft
                </ButtonView>
            )}

            {permissions.notPublished && (
                <ButtonView
                    title={'Mark as Not Published'}
                    theme={'red-on-white'}
                    onClick={onNotPublishedClick}
                    dataId={'disclosure-not-published-btn'}
                    disabled={isLoading}
                >
                    Mark as Not Published
                </ButtonView>
            )}

            {permissions.published && (
                <ButtonView
                    title={'Mark as Published'}
                    theme={'darkgreen-on-white'}
                    onClick={onPublishedClick}
                    dataId={'disclosure-published-btn'}
                    disabled={isLoading}
                >
                    Mark as Published
                </ButtonView>
            )}

            {permissions.save && (
                <ButtonView
                    onClick={onSaveClick}
                    title={'Save'}
                    dataId={'disclosure-save-btn'}
                    disabled={!isDirty || isLoading}
                    theme={'blue-on-white'}
                >
                    Save
                </ButtonView>
            )}

            {permissions.submit && (
                <SubmitButtonView
                    dataId={'disclosure-submit-btn'}
                    disabled={!isValid || isLoading || !documentsForReview || documentsForReview.length <= 0}
                    onClick={onSubmitClick}
                >
                    Submit
                </SubmitButtonView>
            )}
        </div>
    );
};
